export const projects = [
  {
    id: 1,
    title: "Glozzom",
    subtitle: "Responsive application build with bootsrap",
    description: "Created with Bootstrap",
    image: "images/project1.webp",
    fullDesc:
      "Fully responsive pages using Bootstrap.The active link on the navbar has a border on the left when you are on the specified page. Also, clicking on the logo text brings you back to the homepage.The homepage slider has modified indicators and the shadow of the arrow is gone. Clicking on the play icon above “See What We Do”, opens a modal with a video in it. Also there is a gallery where you can open every image in full size in a modal by clicking on it.Some of the background-images have parallax effect on them.",
    isFlipped: false,
  },
  {
    id: 2,
    title: "MovieLibrary",
    subtitle: "Responsive application build with SCSS",
    description: "Created with SCSS",
    image: "images/project2.webp",
    fullDesc:
      "Gallery website full of movie images with the menu bar on the left side fixed. Every image has a link that is displayed when the image is hovered. When the page is open in responsive mode (mobile and tablet), the sidebar menu is switched to a hamburger menu.",
    isFlipped: false,
  },
  {
    id: 3,
    title: "Bike App",
    subtitle: "Responsive application build with React",
    description: "Created with React",
    image: "images/project4.webp",
    fullDesc:
      "Responsive website store for bikes. Ajax request was made to the endpoint to get all the data for the products. All of the effects (on hover) and on click if some of the filters are selected changes accordingly with the active class and active filter. The cards for every bike is created dynamically with JavaScript, looping through the array of objects. The sidebar on the left, the menu & the footer are also created with Javascript.",
    isFlipped: false,
  },
  {
    id: 4,
    title: "Restaurant App",
    subtitle: "Responsive application build with React",
    description: "Created with React",
    image: "images/project5.webp",
    fullDesc:
      "Restaurant application created with React using the React Router. Custom Hooks and Context are used to have the data available in every component and sort, filter and find methods were used to present the data as needed. This page also contains a reviews section and all the reviews are added with ajax - PUT request.",
    isFlipped: false,
  },
  {
    id: 5,
    title: "Portfolio template",
    subtitle: "Responsive application build with CSS",
    description: "Created with CSS using Flex",
    image: "images/project6.webp",
    fullDesc:
      "Portfolio web page with implemented CSS styles. Some of the items in the navbar contain a dropdown menu when you hover over them. The mouse pointer here is changed to a hand.While hovering over the cards border is added around the card. The page is be responsive to mobile devices and additionally when the page is open in responsive mode, the navbar menu is switched to a hamburger menu.",
    isFlipped: false,
  },
  {
    id: 6,
    title: "Responsive template",
    subtitle: "Responsive application build with CSS",
    description: "Created with CSS",
    image: "images/project7.webp",
    fullDesc:
      "Responsive web page created using Flex for positioning the elements. Every image has a description that is displayed when the image is hovered.",
    isFlipped: false,
  },
  {
    id: 7,
    title: "Car magazine",
    subtitle: "Responsive application build with CSS",
    description: "Created with CSS",
    image: "images/project8.webp",
    fullDesc:
      "Responsive web page created using all of the positioning the elements.The background have a parallax effect, except on mobile resolution where be scrollable.",
    isFlipped: false,
  },
  {
    id: 8,
    title: "Blogger",
    subtitle: "Responsive application build with bootsrap",
    description: "Created with Bootstrap",
    image: "images/project9.webp",
    fullDesc:
      "Responsive web page created using Bootstrap.The navbar is fixed to the top and opens the navbar links when clicked on the hamburger menu, on mobile.There is a plus functionality used for this project  and that is the scrollspy. When you scroll the page, the links in the navbar are highlighted.",
    isFlipped: false,
  },
  {
    id: 9,
    title: "Artist albums",
    subtitle: "Responsive application build with React",
    description: "Created with React",
    image: "images/project10.webp",
    fullDesc:
      "Music application created with React. React router was used to make the dynamic routing with one route for every artist and every album.",
    isFlipped: false,
  },
  {
    id: 10,
    title: "Apple devices",
    subtitle: "Responsive application build with CSS",
    description: "Created with CSS using float",
    image: "images/project11.webp",
    fullDesc:
      "Responsive web page created using CSS. The icons for social media items are font-awesome icons that contain links that will open in a new tab when clicked. The items in the navbar are pointing to their sections.",
    isFlipped: false,
  },
];
